<template>
  <div
    v-if="value"
    class="ws-info-color"
    :style="[{'background-color':value.hex},{'opacity':value.alpha}]"
  ></div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info-color.scss";
</style>